import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'uni-swap'),
  es: flattenMessages(es, 'uni-swap'),
  ru: flattenMessages(ru, 'uni-swap'),
  zh: flattenMessages(zh, 'uni-swap'),
};
